import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHDivisionDel = async (credentials, data) => {
    const body = {
        service: "RNHDivisionDel",
        params: {
            rnhDivisionId: data?.id || null,
            rnhDivisionVersion: data?.version ?? null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
